module.exports = __webpack_public_path__ + "img/trash.f37cb29f.svg";